import Vue from 'vue'
import Router from 'vue-router'

import Index from "@/views/index.vue"
import NewList from "@/views/home/newList.vue"
import caseList from "@/views/home/caseList.vue"
import caseDetail from "@/views/home/caseDetail.vue"
import about from "@/views/home/about.vue"
import contact from "@/views/home/contact.vue"
import Context from "@/views/home/context.vue"
import solutionList from "@/views/home/solutionList.vue"
import solutionDetail from "@/views/home/solutionDetail.vue"
import clientList from "@/views/home/clientList.vue"
import join from "@/views/home/join.vue"
import searchList from "@/views/home/searchList.vue"
import honorList from "@/views/home/honorList.vue"
import IpList from '@/views/home/ipList.vue'

Vue.use(Router)

export default new Router({
  scrollBehavior(to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 }
  },
  routes: [{
    path: '/',
    name: 'index',
    component: Index
  },
  {
    path: '/newList',
    name: 'newList',
    component: NewList
  },
  {
    path: '/caseList',
    name: 'caseList',
    component: caseList
  },
  {
    path: '/caseDetail',
    name: 'caseDetail',
    component: caseDetail
  },
  {
    path: '/about',
    name: 'about',
    component: about
  },
  {
    path: '/contact',
    name: 'contact',
    component: contact
  },
  {
    path: '/context',
    name: 'context',
    component: Context
  },
  {
    path: '/solutionList',
    name: 'solutionList',
    component: solutionList
  },
  {
    path: '/solutionDetail',
    name: 'solutionDetail',
    component: solutionDetail
  },
  {
    path: '/clientList',
    name: 'clientList',
    component: clientList
  },
  {
    path: '/join',
    name: 'join',
    component: join
  },
  {
    path: '/searchList',
    name: 'searchList',
    component: searchList
  },
  {
    path: '/honorList',
    name: 'honorList',
    component: honorList
  },
  {
    path: '/ipList',
    name: 'ipList',
    component: IpList
  }
  ]
})